import cn from 'classnames';
import { createElement, forwardRef } from 'react';

import styles from './RichText.module.scss';

export type RichTextProps = {
  field: string | undefined;
  styled?: boolean;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
  role?: string;
};

const RichText = forwardRef<HTMLDivElement, RichTextProps>(function BaseHelpersRichText(
  props: RichTextProps,
  ref
): JSX.Element {
  const { styled = true, className, field, tag = 'div', role } = props;

  if (!field) return <></>;

  const customClassName = className;

  if (field) {
    return createElement(tag, {
      className: cn(styled && styles.main, customClassName),
      ref: ref,
      role,
      dangerouslySetInnerHTML: {
        __html: field,
      },
    });
  }
  return <></>;
});

export default RichText;
